import { atom } from "recoil";

export const orderIdState = atom({
  key: "orderIdState",
  default: null, // Default value can be null or an empty string
});

export const categoriesState = atom({
  key: "categoriesState",
  default: [],
});

export const menuItemsState = atom({
  key: "menuItemsState",
  default: [],
});

export const selectedMenuItemsState = atom({
  key: "selectedMenuItemsState",
  default: {},
});

export const nameState = atom({
  key: "nameState",
  default: "",
});

export const phoneState = atom({
  key: "phoneState",
  default: "",
});

export const emailState = atom({
  key: "emailState",
  default: "",
});
